import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { readSelectedWarehouse, type SelectedWarehouse } from "@/lib/warehouseOps";

/**
 * Kho mà người cầm máy đã chọn ở màn đầu.
 *
 * Chưa chọn kho thì không có việc gì làm được, nên đưa thẳng về màn chọn kho
 * thay vì để màn hình trống hoặc gọi API thiếu tham số.
 */
export function useOpsWarehouse(): SelectedWarehouse | null {
  const navigate = useNavigate();
  const [warehouse] = useState<SelectedWarehouse | null>(() => readSelectedWarehouse());

  useEffect(() => {
    if (!warehouse) navigate("/receiving", { replace: true });
  }, [warehouse, navigate]);

  return warehouse;
}
